import { render, staticRenderFns } from "./ReportingForm.vue?vue&type=template&id=548df7cb&"
import script from "./ReportingForm.vue?vue&type=script&lang=js&"
export * from "./ReportingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports